module.exports = __webpack_public_path__ + "static/Sessun-6e91dbc72cd950f8687f6b825e5a0c0d.jpg";